import ServerResponsibility from "./responsibility/ServerResponsibility";

export const getClassFromIntent = (intent) => {
    let intentClass = ServerResponsibility[intent]
    return intentClass
}
